export default "__VITE_ASSET__047efba5__"